import PaymentUnavailable from '../../components/PaymentUnavailable';
export default function PaymentFailed(){return <PaymentUnavailable context="payment failed route"/>}
